// ================================================================================
// @knowledge_sources
// Traducciones en Español para el módulo Base de Conocimiento.
// ================================================================================

export default {
  KNOWLEDGE_SOURCES: {
    TITLE: 'Base de Conocimiento',
    DESCRIPTION: 'Administra las fuentes de información que alimentan la búsqueda semántica. Conecta foros Discourse o usa las Respuestas Predefinidas para que el asistente encuentre contenido relevante en cada conversación.',

    TABS: {
      INDEXED_CONTENT: 'Contenido indexado',
      SOURCES: 'Fuentes (%{count})',
      SEARCH_CONSOLE: 'Consola de Búsqueda (Fuentes)',
      ERP_CONNECTION: 'Conexión ERP',
      COLLECTION_AGENT: 'Agente Cobrador',
      QUERY_CONSOLE: 'Consola de Consulta (ERP)',
    },

    ACTIONS: {
      ADD: 'Agregar Fuente',
    },

    EMPTY_STATE: 'No hay fuentes de conocimiento configuradas',

    API: {
      FETCH_ERROR: 'Error al cargar las fuentes de conocimiento',
      CREATE_SUCCESS: 'Fuente creada correctamente',
      UPDATE_SUCCESS: 'Fuente actualizada correctamente',
      DELETE_SUCCESS: 'Fuente eliminada correctamente',
      ERROR: 'Ocurrió un error. Intenta de nuevo',
    },
  },
};
